"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PeriodoEncuesta = exports.InfoLogin = exports.TblTelefonoInfo = exports.ImpactoPostgrados = exports.InfoAcademica = exports.InfoLaboral = exports.InfoPersonal = exports.DatosAlumni = void 0;
var DatosAlumni = /** @class */ (function () {
    function DatosAlumni() {
        this.idpersona = 0;
        this.numeroidentificacion = "";
        this.apellidos = "";
        this.nombres = "";
        this.nombrecompleto = "";
        this.email = "";
        this.emailalterno = "";
        this.fechanacimiento = "";
        this.anio = 0;
        this.mes = 0;
        this.dia = 0;
        this.sexo = "";
        this.direcciondomicilio = "";
        this.idpais = 0;
        this.pais = "";
        this.ciudad = "";
        this.idcanton = 0;
        this.codpais = "";
        this.codarea = "";
        this.telefonocelular = "";
        this.nombreunidad = "";
        this.codacad = "";
        this.nombrecarrera = "";
        this.fechagraduacion = "";
        this.aniograduacion = 0;
        this.codestudiante = "";
        this.estadocivil = "";
        this.idnacionalidad = "";
        this.nombreprograma = "";
    }
    return DatosAlumni;
}());
exports.DatosAlumni = DatosAlumni;
var InfoPersonal = /** @class */ (function () {
    function InfoPersonal() {
        //identificacion: string = "";
        this.idpersona = 0;
        this.codestudiante = "";
        this.apellidos = "";
        this.nombres = "";
        this.codnacionalidad = "";
        this.codciudadnacim = "";
        this.fechanacim = "";
        this.coddivisiongrado = "";
        this.codcarreragrado = "";
        this.codespecgrado = "";
        this.estadocivil = "";
        this.email = "";
        this.sexo = "";
        this.autoidentificaciongenero = "";
        this.etnia = "";
        this.tiposangre = "";
        this.discapacidad = "";
        this.codpaisdom = 0;
        this.codprovdom = 0;
        this.codciuddom = 0;
        this.parroqdom = 0;
        this.direccion = "";
        this.direccionalterna = "";
        this.coordenadas = "";
        this.emailalterno = "";
        this.cuentatw = "";
        this.cuentalid = "";
        this.cuentafb = "";
    }
    return InfoPersonal;
}());
exports.InfoPersonal = InfoPersonal;
var InfoLaboral = /** @class */ (function () {
    function InfoLaboral() {
        this.idalumniinfolaboral = 0;
        this.idpersona = 0;
        this.situacionlaboral = "";
        this.motivond = "";
        this.dedicacionreldepen = "";
        this.dedicacionejerindep = "";
        this.relacioncarrera = "";
        this.motivotrabajonr = "";
        this.nombreempresa = "";
        this.emailempresa = "";
        this.idpais = 0;
        this.sectorempresa = 0;
        this.cargoempresa = "";
        this.niveldocencia = "";
        this.cantpersonascargo = 0;
        this.aniosexperiencia = 0;
        this.salariomensual = 0;
        this.idiomatrabajo = "";
        this.tipocomunicacion = "";
        this.tiempoprimertrabajo = "";
        this.primertrabajo = "";
        this.negociopropio = "";
        this.dedicacionnp = "";
        this.aniosnp = 0;
        this.relacionnpcarrera = "";
        this.estudiarespol = "";
        this.motivoestudiar = "";
        this.beneficiosabet = "";
        //ultimoCambio: string = "";
        this.idprovincia = 0;
        this.idcanton = 0;
        this.tamanioempresa = "";
        this.cargojefeinmediato = "";
        this.nombrejefeinmediato = "";
        this.emailjefeinmediato = "";
        this.nombreempresafactura = "";
        this.modalidadtrabajo = "";
        this.areadesempeno = "";
        this.horassemanales = 0;
        this.sectornp = 0;
        this.nombrenp = "";
        this.productonp = "";
        this.trabajoambiente = "";
        this.otraareadesempeno = "";
        this.contactarceproem = "";
        this.otrosectorempresa = "";
    }
    return InfoLaboral;
}());
exports.InfoLaboral = InfoLaboral;
var InfoAcademica = /** @class */ (function () {
    function InfoAcademica() {
        this.idalumniinfoacademica = 0;
        this.idpersona = 0;
        this.estudiosadicionales = "";
        this.tiposcursos = "";
        this.titulopostgrados = "";
        this.modalidadpost = "";
        this.idpais = 0;
        this.relacioncarrera = "";
        this.tipopostgradoencurso = "";
        this.modalidadpostencurso = "";
        this.idpaisencurso = 0;
        this.nomuniencurso = "";
        this.relacioncarrpostencurso = "";
        this.interesadoespol = "";
        //ultimoCambio: string = "";
        this.interes = "";
        this.otrointeres = "";
        this.enviarinformacion = "";
        this.iduniencurso = 0;
        this.nombretitulo = "";
        this.carreraalumni = "";
        this.tipoalumni = "";
        this.fechagraduacion = "";
        this.habilidadadquirida = "";
        this.habilidaddeseada = "";
        this.tipoestudiosadicionales = "";
        this.resolucionproblemas = "";
        this.pensamientocritico = "";
        this.comunicacionespanol = "";
        this.comunicacioningles = "";
        this.responsabilidadetica = "";
        this.trabajoequipo = "";
        this.nuevosconocimientos = "";
        this.creacionvalor = "";
        this.tipopostgrado = "";
        this.otrotipopostgrado = "";
        this.influenciaespol = "";
        this.nombreuni = "";
        this.cursapostgrado = "";
        this.otrotipopostgradoencurso = "";
    }
    return InfoAcademica;
}());
exports.InfoAcademica = InfoAcademica;
var ImpactoPostgrados = /** @class */ (function () {
    function ImpactoPostgrados() {
        this.idalumniimpacto = 0;
        this.idpersona = 0;
        this.oportunidadespostgrados = "";
        this.otrosoportunidades = "";
        this.tiempomejoracondiciones = "";
        this.impactoacreditaciones = "";
        this.motivoimpactonegativo = "";
        this.integracionredprofesional = "";
        this.otrosintegracion = "";
        this.competenciasdesarrolladas = "";
        //ultimoCambio: string = "";
    }
    return ImpactoPostgrados;
}());
exports.ImpactoPostgrados = ImpactoPostgrados;
var TblTelefonoInfo = /** @class */ (function () {
    function TblTelefonoInfo() {
        this.idtelefono = 0;
        this.idpersona = 0;
        this.codigopais = "";
        this.codigoarea = "";
        this.numerotelefono = "";
        this.tipotelefono = "";
        //ultimoCambio: string = 0;
        this.version = 0;
        this.ext = "";
        this.idpais = 0;
        this.estado = "";
    }
    return TblTelefonoInfo;
}());
exports.TblTelefonoInfo = TblTelefonoInfo;
var InfoLogin = /** @class */ (function () {
    function InfoLogin() {
        this.email = "";
        //fecharegistro: string = "";
        this.tiporedsocial = "";
        this.tipoalumni = "";
        //ultimoCambio: string = "";
        this.idalumnisociallogin = 0;
        this.idpersona = 0;
    }
    return InfoLogin;
}());
exports.InfoLogin = InfoLogin;
var PeriodoEncuesta = /** @class */ (function () {
    function PeriodoEncuesta() {
    }
    return PeriodoEncuesta;
}());
exports.PeriodoEncuesta = PeriodoEncuesta;
//# sourceMappingURL=clases_comunes.js.map